function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import PropTypes from 'prop-types';
import { allEvents } from 'make-event-props';
import pdfjs from "../pdfjs.js";
import { isDefined } from "./utils.js";
import LinkService from "../LinkService.js";
var PDFDataRangeTransport = pdfjs.PDFDataRangeTransport;
export var eventProps = function () {
  var result = {};
  allEvents.forEach(function (eventName) {
    result[eventName] = PropTypes.func;
  });
  return result;
}();
var isTypedArray = PropTypes.oneOfType([PropTypes.instanceOf(Int8Array), PropTypes.instanceOf(Uint8Array), PropTypes.instanceOf(Uint8ClampedArray), PropTypes.instanceOf(Int16Array), PropTypes.instanceOf(Uint16Array), PropTypes.instanceOf(Int32Array), PropTypes.instanceOf(Uint32Array), PropTypes.instanceOf(Float32Array), PropTypes.instanceOf(Float64Array)]);
var fileTypes = [PropTypes.string, PropTypes.instanceOf(ArrayBuffer), PropTypes.shape({
  data: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(ArrayBuffer), PropTypes.arrayOf(PropTypes.number.isRequired), isTypedArray]).isRequired
}), PropTypes.shape({
  range: PropTypes.instanceOf(PDFDataRangeTransport).isRequired
}), PropTypes.shape({
  url: PropTypes.string.isRequired
})];
if (typeof Blob !== 'undefined') {
  fileTypes.push(PropTypes.instanceOf(Blob));
}
export var isClassName = PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]);
export var isFile = PropTypes.oneOfType(fileTypes);
export var isLinkService = PropTypes.instanceOf(LinkService);
export var isLinkTarget = PropTypes.oneOf(['_self', '_blank', '_parent', '_top']);
export var isPage = PropTypes.shape({
  commonObjs: PropTypes.shape({}).isRequired,
  getAnnotations: PropTypes.func.isRequired,
  getTextContent: PropTypes.func.isRequired,
  getViewport: PropTypes.func.isRequired,
  render: PropTypes.func.isRequired
});
export var isPageIndex = function isPageIndex(props, propName, componentName) {
  var pageIndex = props[propName],
    pageNumber = props.pageNumber,
    pdf = props.pdf;
  if (!isDefined(pdf)) {
    return null;
  }
  if (isDefined(pageIndex)) {
    if (typeof pageIndex !== 'number') {
      return new Error("`".concat(propName, "` of type `").concat(_typeof(pageIndex), "` supplied to `").concat(componentName, "`, expected `number`."));
    }
    if (pageIndex < 0) {
      return new Error("Expected `".concat(propName, "` to be greater or equal to 0."));
    }
    var numPages = pdf.numPages;
    if (pageIndex + 1 > numPages) {
      return new Error("Expected `".concat(propName, "` to be less or equal to ").concat(numPages - 1, "."));
    }
  } else if (!isDefined(pageNumber)) {
    return new Error("`".concat(propName, "` not supplied. Either pageIndex or pageNumber must be supplied to `").concat(componentName, "`."));
  }
  // Everything is fine
  return null;
};
export var isPageNumber = function isPageNumber(props, propName, componentName) {
  var pageNumber = props[propName],
    pageIndex = props.pageIndex,
    pdf = props.pdf;
  if (!isDefined(pdf)) {
    return null;
  }
  if (isDefined(pageNumber)) {
    if (typeof pageNumber !== 'number') {
      return new Error("`".concat(propName, "` of type `").concat(_typeof(pageNumber), "` supplied to `").concat(componentName, "`, expected `number`."));
    }
    if (pageNumber < 1) {
      return new Error("Expected `".concat(propName, "` to be greater or equal to 1."));
    }
    var numPages = pdf.numPages;
    if (pageNumber > numPages) {
      return new Error("Expected `".concat(propName, "` to be less or equal to ").concat(numPages, "."));
    }
  } else if (!isDefined(pageIndex)) {
    return new Error("`".concat(propName, "` not supplied. Either pageIndex or pageNumber must be supplied to `").concat(componentName, "`."));
  }
  // Everything is fine
  return null;
};
export var isPdf = PropTypes.oneOfType([
// Ideally, this would be `PropTypes.instanceOf(PDFDocumentProxy)`, but it can't be imported.
PropTypes.any, PropTypes.oneOf([false])]);
export var isRef = PropTypes.oneOfType([PropTypes.func, PropTypes.exact({
  current: PropTypes.any
})]);
export var isRenderMode = PropTypes.oneOf(['canvas', 'custom', 'none', 'svg']);
export var isRotate = PropTypes.oneOf([0, 90, 180, 270]);